import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { Flex, Link, Menu as UikitMenu } from 'vvs-uikit'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { isBlindMode } from 'utils'
import { useAppDispatch } from 'state'
import { usePollBlockNumber } from 'state/block/hooks'
import styled from 'styled-components'
import { Path } from 'config/constants/paths'
import { socials } from 'config/constants/socials'
import { toggleMenuDisplay } from 'state/menu/actions'

import { footerLinks } from './config/footerConfig'
import { getVvsMinerMoleMenuConfig } from './config/config'
import UserMenu from './UserMenu'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'

const socialConfigs = [socials.discord, socials.tg, socials.twitter]
const VvsMinerMoleMenu = ({ children }) => {
  usePollBlockNumber()

  const dispatch = useAppDispatch()
  const { isDark, toggleTheme } = useTheme()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useLocation()

  const menuConfig = useMemo(() => getVvsMinerMoleMenuConfig(t), [t])
  const activeMenuItem = getActiveMenuItem({ menuConfig, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  return (
    <UikitMenu
      onChangeMenuVisibility={(isDisplay) => {
        dispatch(toggleMenuDisplay({ isDisplay }))
      }}
      rightHandSideMenu={
        <Flex gap="1rem" mr="1rem">
          {socialConfigs.map(({ href, Icon }) => {
            return (
              <Link href={href} target="_blank">
                <Icon color="white" width={24} height={24} />
              </Link>
            )
          })}
        </Flex>
      }
      useBurgerMenu
      homeIcon={
        <HomeLink href={Path.VVS_MINER_MOLE}>
          <img src="/images/vvsMinerMole/vvs_miner_mole_logo.png" alt="vvs miner mole home link icon button" />
        </HomeLink>
      }
      userMenu={<UserMenu />}
      isDark={isDark}
      isBlindMode={isBlindMode()}
      toggleTheme={toggleTheme}
      t={t}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      links={menuConfig}
      subLinks={activeMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
      footerLinks={footerLinks(t)}
      activeItem={undefined}
      activeSubItem={activeSubMenuItem?.href}
      buyVvsLabel=""
    >
      {children}
    </UikitMenu>
  )
}

export default VvsMinerMoleMenu

const HomeLink = styled(Link)`
  flex-basis: 72px;
  flex-shrink: 0;
`
